import moment from 'moment-timezone'

const utcOffsets = moment.tz.names().map(item => {
  return {
    value: item,
    label: item + '(' + moment.tz(item).utcOffset() / 60 + ')'
  }
})

const tagOptions = [
  'Run away line',
  'Non responsive line',
  'Divergence',
  'Disconnected line',
  'Saturated readings',
  'sit/stand inaccuracy',
  'sensor line drop',
  'Unexplained'
]

const pass = 'PASS'
const environments = {
  production: 'Production',
  staging: 'Staging'
}

const defaultBaseUrls = {
  commonBaseUrl: 'https://configs.smartzhealth.com/api',
  reportBaseUrl: 'https://api.smartzhealth.com',
  signalRUrl: 'https://utility.smartzhealth.com/api',
  loraBaseUrl: 'https://configs.smartzhealth.com'
}

const regionBaseUrls = {
  eu: {
    reportBaseUrl: defaultBaseUrls.reportBaseUrl,
    signalRUrl: defaultBaseUrls.signalRUrl
  },
  au: {
    reportBaseUrl: 'https://au-api.smartzhealth.com',
    signalRUrl: 'https://au-utility.smartzhealth.com/api'
  }
}

const baseUrls = { ...defaultBaseUrls }

const normalizeRegionCode = region =>
  typeof region === 'string' ? region.trim().toLowerCase() : ''

const applyRegionBaseUrls = region => {
  const normalizedRegion = normalizeRegionCode(region) || 'eu'
  const urls = regionBaseUrls[normalizedRegion] || regionBaseUrls.eu

  baseUrls.reportBaseUrl = urls.reportBaseUrl
  baseUrls.signalRUrl = urls.signalRUrl
  return regionBaseUrls[normalizedRegion] ? normalizedRegion : 'eu'
}

// Apply the browser preference before any page can start API or SignalR work.
const initialRegion = applyRegionBaseUrls(
  localStorage.getItem('preferredRegion') || 'eu'
)
localStorage.setItem('preferredRegion', initialRegion)

const allPermissionAccount = 'simavita'

const googlePlacesApiKey = 'AIzaSyCY-jvzw8QEfenKdUPcKC6Oz-JF1zhcrvs'

const azureAD = {
  clientId: 'c5ea04fb-eba0-48b2-adc0-0041b9bbb84a',
  tenantId: '3fa954f0-6d95-4bc4-b593-3cc43582c0e5',
  redirectUri: window.location.origin.replace(/\/$/, '') + '/login/',
  scope:
    'api://b84df86d-7f62-41f5-8e38-a5431ffff21b/access_as_user offline_access'
}

const subscriptionCodeStatus = {
  trial: 'TRIAL',
  approved: 'APPROVED',
  disabled: 'DISABLED'
}

const jobTypes = {
  backTestingVolumeEstimation: 'back-testing-volume-estimation',
  backTestingRedAlert: 'back-testing-redalert',
  backTestingNewPad: 'back-testing-newpad',
  modelGenerator: 'job-model-generator'
}

export {
  utcOffsets,
  baseUrls,
  regionBaseUrls,
  applyRegionBaseUrls,
  normalizeRegionCode,
  allPermissionAccount,
  azureAD,
  googlePlacesApiKey,
  tagOptions,
  pass,
  environments,
  subscriptionCodeStatus,
  jobTypes
}
